export const WEB_GET = "WEB_GET";
export const WEB_SUCCESS = "WEB_SUCCESS";
export const WEB_ERROR = "WEB_ERROR";
export default {};
